"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*exported AnD_352 */

var AnD_352_reader = function (_AnD_Ble_reader) {
  _inherits(AnD_352_reader, _AnD_Ble_reader);

  function AnD_352_reader() {
    _classCallCheck(this, AnD_352_reader);

    return _possibleConstructorReturn(this, (AnD_352_reader.__proto__ || Object.getPrototypeOf(AnD_352_reader)).apply(this, arguments));
  }

  _createClass(AnD_352_reader, [{
    key: "onConnect",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
        var result, settings;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!params.units) {
                  _context.next = 10;
                  break;
                }

                _context.next = 3;
                return this.setUnits(params.units);

              case 3:
                result = _context.sent;

                if (!result.ok) {
                  _context.next = 10;
                  break;
                }

                console.log("units set");
                result.unitsSet = true;
                result.ok = false;
                console.log(result);
                throw result;

              case 10:
                _context.next = 12;
                return this.readSettings();

              case 12:
                settings = _context.sent;

                if (!settings.hasBuffer) {
                  _context.next = 21;
                  break;
                }

                // this will also clear the measurement they just took 
                // and the scale will disconnect, but it will only happen once.
                console.log("HAS BUFFER - clearing");
                _context.next = 17;
                return this.setNumberOfMeasurements(0);

              case 17:
                _context.next = 19;
                return this.sendDisconnect();

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.next = 23;
                return this.getBatteryStatus();

              case 23:
                _context.next = 25;
                return this.setClockCustom(new Date());

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onConnect(_x) {
        return _ref.apply(this, arguments);
      }

      return onConnect;
    }()
  }, {
    key: "onFinish",
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.sendDisconnect();

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onFinish() {
        return _ref2.apply(this, arguments);
      }

      return onFinish;
    }()
  }]);

  return AnD_352_reader;
}(AnD_Ble_reader);

var AnD_352 = new JS.Class(BLE_Device, {
  initialize: function initialize(device_uuid) {
    var name = "A&D Medical 352BLE";
    var model_name = "UC-352BLE";

    return this.callSuper(name, model_name, device_uuid, '181D', ['2A9D']);
  },

  alternateService: function alternateService() {
    return { service_uuid: '23434100-1fe4-1eff-80cb-00ff78297d8b',
      measurement_uuids: ['23434101-1fe4-1eff-80cb-00ff78297d8b'] };
  },

  getAdvertisedName: function getAdvertisedName() {
    return "A&D_UC-352BLE_" + this.ble_id.replace(/\:/g, "").slice(-6).toUpperCase();
  },

  needsPairing: function needsPairing() {
    return true;
  },

  needsInitialConnect: function needsInitialConnect() {
    return true; // trying to rescan after a failure causes problems without this
  },

  settableUnits: function settableUnits() {
    return [];
  },

  makeReader: function makeReader() {
    return new AnD_352_reader(this);
  },

  _decode_result: function _decode_result(result, reader) {

    var result_byte_array = new Uint8Array(result);

    var flags = this._decode_flags_byte(result_byte_array[0]);

    var wt;
    if (reader.service_uuid == '181D') {
      var rawVal = (result_byte_array[2] << 8) + result_byte_array[1];
      if (flags.unit == "kg") {
        rawVal = rawVal >> 1;
      }
      wt = new bigdecimal.BigDecimal(rawVal + "e-2");
    } else {
      // old model
      var _rawVal = (result_byte_array[2] << 8) + result_byte_array[1];
      wt = new bigdecimal.BigDecimal(_rawVal + "e-1");
    }

    console.log(result_byte_array);
    console.log(flags);
    console.log(wt.toString());

    var date = new Date();

    var designations = [];

    return {
      valid: true,
      status: status,
      batteryStatus: this.batteryStatus,
      date: date,
      readings: [{ main: true,
        measurements: [{ name: "wt", value: wt.toString(), unit: flags.unit, designations: [] }]
      }]
    };
  },

  _decode_flags_byte: function _decode_flags_byte(flags) {

    return {
      unit: (flags & 0x01) == 0x01 ? 'lbs' : 'kg',
      time_stamp: (flags & 0x02) == 0x02 ? true : false
    };
  }

});